import storage from '@/utils/storage'
const app = {
    state: {
        os: "",
        deviceToken:storage.get('deviceToken'),
    },
    getters: {
        os: state => {
            return state.os
        },
        deviceToken: state => {
            return state.deviceToken
        },
    },
    mutations: {
        setOs(state, os) {
            state.os = os;
        },
        setDeviceToken(state, deviceToken) {
            if(deviceToken && deviceToken!=="null") {
                storage.set('app-deviceToken', deviceToken);
                state.deviceToken = deviceToken;
            }
        },
    },
}

export default app